export let HubTypeId;

(function (HubTypeId) {
  HubTypeId[HubTypeId["MarketingFree"] = 0] = "MarketingFree";
  HubTypeId[HubTypeId["SalesFree"] = 1] = "SalesFree";
  HubTypeId[HubTypeId["Service"] = 2] = "Service";
  HubTypeId[HubTypeId["Crm"] = 3] = "Crm";
})(HubTypeId || (HubTypeId = {}));